module.exports = __webpack_public_path__ + "img/编组 4.c74722f4.png";